  <app-mat-spinner-overlay *ngIf="showSpinner"> </app-mat-spinner-overlay>

<div class="money-collection-dashboard">
  <div class="container-fluid mt-4">

    
    <!-- Filters Section -->
    <form
      #df="ngForm"
      novalidate
      (keydown.enter)="loadDashboardData()"
      class="formborder"
    >
      <div class="col-md-12 row m-0">
        <div class="col-md-3">
          <span class="required-lable"> From Date </span>
          <div class="datepicker_feild">
            <input
              [matDatepicker]="picker"
              dateConvert
              placeholder="DD/MM/YYYY"
              name="FromDate"
              id="FromDate"
              #refFromDate="ngModel"
              (dateChange)="DateChange()"
              required
              class="form-control input-text-css"
              [(ngModel)]="FromDate"
              [ngClass]="{
                'is-invalid': df.submitted && refFromDate.invalid,
                'alert-warning':
                  refFromDate.invalid &&
                  (refFromDate.dirty || refFromDate.touched || refFromDate.untouched)
              }"
            />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </div>
        </div>

        <div class="col-md-3">
          <span class="required-lable"> To Date </span>
          <div class="datepicker_feild">
            <input
              [matDatepicker]="picker2"
              dateConvert
              placeholder="DD/MM/YYYY"
              name="ToDate"
              id="ToDate"
              #refToDate="ngModel"
              (dateChange)="DateChange()"
              required
              class="form-control input-text-css"
              [(ngModel)]="ToDate"
              [ngClass]="{
                'is-invalid': df.submitted && refToDate.invalid,
                'alert-warning':
                  refToDate.invalid &&
                  (refToDate.dirty || refToDate.touched || refToDate.untouched)
              }"
            />
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
          </div>
        </div>

        <div class="col-md-2">
          <button
            type="button"
            (click)="loadDashboardData()"
            class="mt-3 btn font-size-12 button-btn"
            [disabled]="!df.form.valid"
          >
            Search
          </button>
        </div>

      </div>
    </form>

    <div class="dashboard-header">
    <div class="header-card total-collection">
      <div class="header-label header-badge positive">TOTAL COLLECTION</div>
      <div class="header-value">{{ totalCollection?.Amount | currency:'INR':'symbol':'1.2-2'}}</div>
      <!-- <div class="header-badge positive">
        <i class="fa fa-arrow-up"></i> +15.2%
      </div> -->
    </div>
    <div class="header-card active-transactions">
      <div class="header-label header-badge live">TOTAL VOUCHERS</div>
      <div class="header-value">{{ totalCollection?.Voucher_Count || 0 }}</div>
      <!-- <div class="header-badge live">
        <i class="fa fa-circle"></i> Live
      </div> -->
    </div>
  </div>
  
    <!-- DASHBOARD CARDS: Full-width, expandable -->
    <div class="dashboard-cards">
      <div
        class="dashboard-card"
        *ngFor="let item of JsonData"
        [class.expanded]="isExpanded(item.Collection_Type)"
        (click)="toggleExpand(item)"
      >
        <div class="card-header">
          <div class="card-title">
            <span class="card-icon">{{ (categoryConfig && categoryConfig[item.Collection_Type]?.icon) || '📦' }}</span>
            <div class="card-text">
            <span class="card-name">{{ (categoryConfig && categoryConfig[item.Collection_Type]?.title) || item.Collection_Type || 'Collection' }}</span>
            <span class ="card-per"> ({{ calculateVoucherPercentage(item.Amount) }})</span>
            </div>          
          </div>
          <div class="card-amount">
            {{ item.Amount | currency:'INR':'symbol':'1.2-2' }}
          </div>
          <div class="card-vouchers">
            <span class="badge badge-success">{{ item.Voucher_Count }} Vouchers</span>
          </div>
          <button class="btn-toggle-expand" type="button" tabindex="-1" (click)="toggleExpand(item); $event.stopPropagation()">
            <span *ngIf="!isExpanded(item.Collection_Type)">▼</span>
            <span *ngIf="isExpanded(item.Collection_Type)">▲</span>
          </button>
        </div>

        <!-- Expanded Mode-level summary cards (ModeId = "") -->
        <div class="card-body" *ngIf="isExpanded(item.Collection_Type)">
          <div class="mode-boxes">
            <div
              class="mode-box"
              *ngFor="let mode of ModeData"
              (click)="openModeDetail(mode); $event.stopPropagation()"
            >
              <div class="mode-title">{{ mode.CollectionName }} <span> ({{ calculateVoucherPercentage(mode.Amount) }})</span></div>
              <div class="mode-amount">₹{{ mode.Amount | number:'1.2-2' }}</div>
              <div class="mode-vouchers">{{ mode.Voucher_Count }} Vouchers</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

<!-- Voucher-level details modal -->
<div *ngIf="showModal" class="modal fade in show" tabindex="-1" role="dialog" aria-labelledby="voucherModalLabel"
     style="display: block; background-color: rgba(0, 0, 0, 0.5); overflow: auto;">
  <div class="modal-dialog modal-lgx modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content voucher-modal-content">

      <!-- Header -->
      <div cdkDragHandle class="modal-header voucher-modal-header">
        <h6 class="modal-title" id="voucherModalLabel">Details for {{ modalTitle }}</h6>
        <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close" style="background: none; border: none;">
          <span aria-hidden="true"><i class="far text-black fa-times-circle"></i></span>
        </button>
      </div>

      <!-- Body -->
      <div class="modal-body voucher-modal-body">
        <div class="table-responsive">
          <table mat-table matSort matTableExporter [dataSource]="selectedDetailDataSource" class="mat-elevation-z2 mat-table-responsive"
                 *ngIf="selectedDetailData?.length > 0" id="collection-summary" >

            <ng-container matColumnDef="Id">
            <th mat-sort-header mat-header-cell *matHeaderCellDef>#</th>
            <td mat-cell *matCellDef="let row; let i = index">
              {{ paginatorRef.pageIndex * paginatorRef.pageSize + (i + 1) }}
            </td>
            <th mat-footer-cell *matFooterCellDef></th>
          </ng-container>

            <ng-container matColumnDef="CaseNo">
              <th mat-header-cell *matHeaderCellDef>Case No</th>
              <td mat-cell *matCellDef="let row">{{ row.CaseNo }}</td>
              <th mat-footer-cell *matFooterCellDef class="text-center">Total:</th>
            </ng-container>
            <ng-container matColumnDef="Collection_Mode">
              <th mat-header-cell *matHeaderCellDef>Collection Mode</th>
              <td mat-cell *matCellDef="let row">{{ row.Collection_Mode }}</td>
              <th mat-footer-cell *matFooterCellDef></th>
            </ng-container>

            <ng-container matColumnDef="Customer_Name">
              <th mat-header-cell *matHeaderCellDef>Customer</th>
              <td mat-cell *matCellDef="let row">{{ row.Customer_Name }}</td>
              <th mat-footer-cell *matFooterCellDef></th>
            </ng-container>

            <ng-container matColumnDef="Voucher_Date">
              <th mat-header-cell *matHeaderCellDef>Voucher Date</th>
              <td mat-cell *matCellDef="let row">{{ row.Voucher_Date | date: 'dd-MMM-yyyy' }}</td>
              <th mat-footer-cell *matFooterCellDef></th>
            </ng-container>

            <ng-container matColumnDef="Voucher_No">
              <th mat-header-cell *matHeaderCellDef>Voucher No</th>
              <td mat-cell *matCellDef="let row">{{ row.Voucher_No }}</td>
              <th mat-footer-cell *matFooterCellDef></th>
            </ng-container>

            <ng-container matColumnDef="Voucher_Type">
              <th mat-header-cell *matHeaderCellDef>Voucher Type</th>
              <td mat-cell *matCellDef="let row">{{ row.Voucher_Type }}</td>
              <th mat-footer-cell *matFooterCellDef></th>
            </ng-container>

            <ng-container matColumnDef="Amount">
              <th mat-header-cell *matHeaderCellDef>Amount</th>
              <td mat-cell *matCellDef="let row">{{ row.Amount | currency:'INR':'symbol':'1.2-2'}}</td>
              <th mat-footer-cell *matFooterCellDef class="text-right">
              {{ totaltypewise("Amount") | number:'1.2-2' }}
            </th>
            </ng-container>
             <ng-container matColumnDef="Remark">
              <th mat-header-cell *matHeaderCellDef>Remark </th>
              <td mat-cell *matCellDef="let row">{{ row.Remark }}</td>
              <th mat-footer-cell *matFooterCellDef></th>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="modalDisplayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: modalDisplayedColumns;"></tr>
            <tr mat-footer-row class="sticky-footer fontcolor" *matFooterRowDef="modalDisplayedColumns; sticky: true"
            style="background: #4dc3a3"></tr>
          </table>
          <p *ngIf="!selectedDetailData?.length">No details found.</p>
          <div class="row m-0 align-items-center d-flex justify-content-between align-items-center">
            <div class="col-md-2">
              <button class="mt-3 btn font-size-12 button-btn" (click)="exportTable(exporter)">
                <i class="fa fa-file-export mr-1" style="font-size: medium; cursor: pointer"></i>
                Export
              </button>
            </div>

            <div class="col-md-3 mt-1">
              <form action="" class="search-text">
                <div class="bg-light rounded rounded-pill shadow-sm">
                  <div class="input-group">
                    <input type="text" id="FilterInputSearch" (keyup)="applyFilter($event.target.value)"
                      name="FilterInputSearch" placeholder="What're you searching for?"
                      class="form-control border-0 bg-light" />
                    <div class="input-group-append">
                      <button id="button-addon1" type="submit" class="btn btn-link text-primary">
                        <i class="fa fa-search"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="col-md-6">
              <mat-paginator #paginatorRef [pageSizeOptions]="[20, 50]" showFirstLastButtons>
              </mat-paginator>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

